export default {"src":"/_next/static/media/readySite5.a25f40b3.svg","height":192,"width":220,"blurWidth":0,"blurHeight":0};